import Image from "next/image"
import { SecondaryButton } from "../SecondaryButton"
import Recruiter from '../../../public/assets/recruiter.webp'
import { useRouter } from 'next/router'
function RecruiterBanner()
{
    const router = useRouter();
    return <div id="recruiter-banner" className="mt-[56px]  flex flex-col items-center justify-center rounded-[24px] border-solid border-greyDisabledBackground50 w-[85%]">
        <div id="recruiter-head" className="aspect-[320/215] rounded-t-[24px] w-[100%]">
            <Image src={Recruiter} alt="recruiter" className="rounded-t-[24px] h-full w-[100%]"/>

        </div>
        <div id="recruiter-body" className="h-[50%] p-[24px] custom-gradient-banner text-left rounded-[24px] w-[100%]">
            <div className="text-[24px] font-noto-sans mb-[24px] text-left font-[600] text-greyTitleBase900 w-[100%]">
            Looking to hire? Check out our platform for recruiters.
            </div>
            <div className="w-[44%]">
            <SecondaryButton title={"Post a Job"}  onClick={()=>{
                router.push(`/hire`)
            }} className='whitespace-nowrap h-[48px] border-[#989898]'/>

            </div>
  
            

        </div>
    </div>

}

export default RecruiterBanner